<template>
    <div>
        <div class="page-title">
            <span>项目老师列表</span>
            <button class="btn" @click="createTeacher">新增项目老师</button>
        </div>
        <a-table :data-source="list" size="small" :pagination="pagination" :rowKey="(record, index) => (record, index)">
            <a-table-column title="项目老师" width="130px">
                <template slot-scope="val">
                    <div class="teacher">
                        <img :src="val.avatar">
                        <span>{{ val.name }}</span>
                    </div>
                </template>
            </a-table-column>
            <a-table-column title="老师简介" width="530px">
                <template slot-scope="val">
                    <div class="summary">{{ val.summary }}</div>
                </template>
            </a-table-column>
            <a-table-column title="操作" align="center" width="70px">
                <template slot-scope="val">
                    <div class="op-box">
                        <div class="op-item" @click="handleEdit(val)">
                            <img src="/assets/icons/input-edit.png" />
                        </div>
                        <a-popconfirm title="确定删除该老师吗？" placement="topRight" @confirm="handleDelete(val)">
                            <div class="op-item" style="cursor: pointer;">
                                <img src="/assets/icons/input-del.png" />
                            </div>
                        </a-popconfirm>
                    </div>
                </template>
            </a-table-column>
        </a-table>

        <TeacherCreate ref="createTeacher" @created="handleCreated" />
    </div>
</template>

<script>
import api from '@/repo/api';
import TeacherCreate from './components/create.vue';

export default {
    name: 'TeacherList',
    components: {
        TeacherCreate,
    },
    data() {
        return {
            list: [],
            loading: false,
            pagination: {
                current: 1,
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                showTotal: (total) => `共 ${total} 条数据`,
                pageSizeOptions: ['10', '20', '50', '100'],
                total: 0
            },
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        createTeacher() {
            this.$refs.createTeacher.open();
        },
        getList() {
            this.loading = true;
            const params = {
                page: this.pagination.current,
                pageSize: this.pagination.pageSize
            };
            api.get('/ast-appointment/teacher-list', params).then(res => {
                this.loading = false;
                if (res.code === 0) {
                    this.list = res.data.data || [];
                    this.pagination.total = res.data.total || 0;
                }
            }).catch(() => {
                this.loading = false;
            })
        },
        tableChanged(pagination) {
            this.pagination = pagination;
            this.getList();
        },
        handleCreated() {
            // 新增成功后刷新列表
            this.getList();
        },
        handleEdit(record) {
            console.log('List.vue传递给编辑组件的record数据:', record);
            // 确保组件引用存在
            if (this.$refs.createTeacher) {
                this.$refs.createTeacher.open(record);
            } else {
                console.error('createTeacher组件引用不存在');
            }
        },
        handleDelete(item) {
            console.log('删除老师:', item);
            this.deleteTeacher(item.id);
        },

        deleteTeacher(id) {
            api.post('/ast-appointment/teacher-delete', { id }).then(res => {
                if (res.code === 0) {
                    this.$message.success('删除成功');
                    this.getList();
                } else {
                    this.$message.error(res.msg || '删除失败');
                }
            }).catch(() => {
                this.$message.error('删除失败');
            });
        }
    }

}
</script>

<style lang="scss" scoped>
.page-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    span {
        font-size: 20px;
        font-weight: bold;
    }
}

.teacher {
    display: flex;
    align-items: center;

    img {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        object-fit: cover;
        margin-right: 16px;
    }

    span {
        font-size: 14px;
        color: #333;
    }
}

.summary {
    color: #999;
    font-size: 14px;
    line-height: 20px;
}

/deep/ .ant-table-small {
    border: none;
}

/deep/ .ant-table-thead>tr>th {
    color: #999;
    font-size: 14px;
    line-height: 50px;
}
    .op-box{
        width: 100%;
        display: flex;
        justify-content: center;
        .op-item{
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            padding: 0 8px;
            img{
                width: 24px;
                height: 24px;
            }
        }
    }
</style>
